import ListPage from '@/pages/seo-templates/ListPage'
import CreateUpdatePage from '@/pages/seo-templates/CreateUpdatePage'

export default [
  {
    path: '/seo-templates/category-city/list',
    name: 'SeoTemplatesList',
    component: ListPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/seo-templates/category-city/create',
    name: 'CreateSeoTemplate',
    component: CreateUpdatePage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/seo-templates/category-city/update/:id',
    name: 'UpdateSeoTemplate',
    component: CreateUpdatePage,
    meta: {
      requiresAuth: true,
    },
  },
]
